<template>
    <section id="hero-21" class="bg-snow hero-section division">
        <div class="container">
            <div class="row d-flex align-items-center">


                <!-- HERO TEXT -->
                <div class="col-md-10 offset-md-1">
                    <div class="hero-21-txt text-center">

                        <!-- Title -->
                        <h2 class="h2-lg">Achieving The Credit Scores You Want Should Be Easy and Now It Is!</h2>

                        <!-- Text -->
                        <p class="">
                            Creditfixrr.com is a <strong>DIY And Business Credit</strong> Restoration software. 
                            We provide you with <strong> the Knowledge, Tools, Resources &amp; Dispute Flows
                            </strong> to help you to <strong>Improve your Credit</strong> and increase <strong>your Credit Scores</strong>. 
                        </p>

                        <!-- HERO QUICK FORM -->
                        <form name="quickform" class="quick-form">

                            <!-- Form Inputs -->
                            <div>
                                <!-- <input type="email" name="email" class="form-control email" placeholder="Your email address" autocomplete="off" required> -->
                                <a href="/register" class="dtr-btn-flat btn-outline-secondary dtr-px-50 mr-2 ">Create Free Account</a>
                                <a class="dtr-video-popup dtr-btn-flat btn-green dtr-px-50" data-autoplay="true" data-vbtype="video" href="/login">Login Now</a>
                            </div>

                            <!-- Form Message -->
                            <div class="quick-form-msg"><span class="loading"></span></div>

                        </form>

                        <!-- Advantages List -->
                        <ul class="advantages mt-35">
                            <li><p>{{ planStore.trialDays }} days free trial</p></li>
                            <li class="last-li"><p>Improve Your Credit Scores</p></li>
                        </ul>

                    </div>
                </div>	<!-- END HERO TEXT -->


            </div>	   <!-- End row -->
        </div>	   <!-- End container -->
    </section>	<!-- END HERO-21 -->
</template>
<script>
    import { usePlanStore } from '../../stores/PlanStore.js'
    export default{
        name:'HeaderSection',
        setup(props) {
            return {
                planStore: usePlanStore(),
            }
        },
    }
</script>
